const direct_to_garment = [
    {
        label: "T-Shirt",
        value: "t_shirt",
    },
    {
        label: "Hoodie",
        value: "hoodie",
    },
    {
        label: "Polo Shirt (mens version)",
        value: "polo_shirt",
    },
    {
        label: "Raglan Long Sleeve",
        value: "raglan_long_sleeve",
    },
    {
        label: "Women's Leggings",
        value: "womens_leggings",
    },
    {
        label: "Tank Top (mens version)",
        value: "tank_top",
    },
    {
        label: "Baby Onesie",
        value: "baby_onesie",
    },
    {
        label: "Tote Bag",
        value: "tote_bag",
    },
    {
        label: "Sweat Pants",
        value: "sweat_pants",
    },
    {
        label: "Shorts",
        value: "shorts",
    },
];

const dye_sublimation = [
    {
        label: "T-Shirt",
        value: "t_shirt",
    },
    {
        label: "Hoodie",
        value: "hoodie",
    },
    {
        label: "Polo Shirt (mens version)",
        value: "polo_shirt",
    },
    {
        label: "Raglan Long Sleeve",
        value: "raglan_long_sleeve",
    },
    {
        label: "Women's Leggings",
        value: "womens_leggings",
    },
    {
        label: "Tank Top (mens version)",
        value: "tank_top",
    },
    {
        label: "Baby Onesie",
        value: "baby_onesie",
    },
    {
        label: "Messenger Bag",
        value: "messenger_bag",
    },
    {
        label: "Tote Bag",
        value: "tote_bag",
    },
    {
        label: "Sweat Pants",
        value: "sweat_pants",
    },
    {
        label: "Shorts",
        value: "shorts",
    },
];

const embroidery = [
    {
        label: "Hat",
        value: "hat",
    },
    {
        label: "T-Shirt",
        value: "t_shirt",
    },
    {
        label: "Hoodie",
        value: "hoodie",
    },
    {
        label: "Polo Shirt (mens version)",
        value: "polo_shirt",
    },
    {
        label: "Raglan Long Sleeve",
        value: "raglan_long_sleeve",
    },
    {
        label: "Tank Top (mens version)",
        value: "tank_top",
    },
    {
        label: "Baby Onesie",
        value: "baby_onesie",
    },
    {
        label: "Messenger Bag",
        value: "messenger_bag",
    },
    {
        label: "Tote Bag",
        value: "tote_bag",
    },
    {
        label: "Sweat Pants",
        value: "sweat_pants",
    },
    {
        label: "Shorts",
        value: "shorts",
    },
];

export const GARMENT_OPTIONS = {
    direct_to_garment,
    dye_sublimation,
    embroidery,
};